<template>
  <div class="am-finance-contract-modal">
    <div class="am-finance-contract-header">
      <span>Request Finance Quote</span>
    </div>
    <div class="am-finance-contract-body">
        <div class="form-row am-finance-contract-main-table">
          <table class="am-finance-contract-table">
            <tbody>
            <tr  v-if="isEnteredManual()" >
              <td >
                Entered Manual?
              </td>
              <td class="am-finance-contract-toggle">
                <yes-no-switch v-model="financeAttributes.attributes.isManualContract"></yes-no-switch>
              </td>
            </tr>
            <tr v-if="!isEnteredManualActive">
              <td >
                Assigned Risk?
              </td>
              <td class="am-finance-contract-toggle">
                <yes-no-switch v-model="financeAttributes.attributes.assignedRisk"></yes-no-switch>
              </td>
            </tr>
            <tr v-if="!isEnteredManualActive">
              <td>
                Is SR22?
              </td>
              <td class="am-finance-contract-toggle">
                <yes-no-switch v-model="financeAttributes.attributes.other"></yes-no-switch>
              </td>
            </tr>
            <tr v-if="financeAttributes.insuranceType === 'Commercial' && !isEnteredManualActive">
              <td >
                Auditable?
              </td>
              <td class="am-finance-contract-toggle">
                <yes-no-switch v-if="!isEnteredManualActive" v-model="financeAttributes.attributes.auditable"></yes-no-switch>
              </td>
            </tr>
            <tr v-if="financeAttributes.insuranceType === 'Commercial' && !isEnteredManualActive">
              <td >
                Federal Filing?
              </td>
              <td class="am-finance-contract-toggle">
                <yes-no-switch v-if="!isEnteredManualActive" v-model="financeAttributes.attributes.parameterCode"></yes-no-switch>
              </td>
            </tr>
            <tr v-if="transactionType === 'quote'">
              <td >
                Additional Premium:
              </td>
              <td class="am-finance-contract-toggle">
                <money type="text" name="additionalPremium" value="0.00" v-model="financeAttributes.additionalPremium" v-bind="money"/>
              </td>
            </tr>
            </tbody>
          </table>
      </div>
    </div>
    <div class="finance-contract-footer">
      <button type="button" class="btn btn-secondary btn-xs" @click="closeModal()">Cancel</button>
      <button type="button" class="btn btn-primary btn-xs" @click="submit" title="Close">{{quoteButtonLabel}}</button>
    </div>
    <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3"  :adaptive="true" width="370px" height="auto">
      <message-popup :confirmDelete="false" :errors="messageString" messageHeader="Error" :isError="true"/>
    </modal>
  </div>
</template>

<script>
import api from './../http'
import PaymentSelection from "./PaymentSelection"
import MessagePopup from "./MessagePopup"
import { Money, VMoney } from 'v-money'
export default {
  name: 'FinanceContract',
  props: {
    policyIds: {
      type: String,
      default: ''
    },
    insuranceType: {
      type: String,
      default: ''
    },
    transactionType: {
      type: String,
      default: ''
    },
    companyId: {
        type: Number,
        default: 0
    },
    requote: {
      type: String,
      default: ''
    },
    policyMinDate: {
      type: String,
      default: ''
    },
    customerId:{
      type: Number,
      default: null
    },
    isManualContract:{
      type: Number,
      default: 0
    },
    amountsIfAddOn: {
      type: String,
      default: ''
    },
    additionalPremium:{
      type: Number,
      default: 0.00
    },
    recordName:{
      type: String,
      default: ''
    }
  },

  data () {
    return {
      financeAttributes: {
        policyIds: [],
        insuranceType: '',
        transactionType: '',
        attributes: {
          assignedRisk: null,
          other: null,
          auditable: null,
          parameterCode: null,
          isManualContract: 0
        },
        companyId: 0,
        additionalPremium: 0,
        recordName: ''
      },
        messageString: '',
        quoteButtonLabel: 'Request a Quote',
        isEnteredManualActive: 0,
        customerId: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        masked: false
      }
    }
  },
  directives: {
    money: VMoney
  },

  mounted () {
    this.financeAttributes.policyIds = this.policyIds.split(',')
    this.financeAttributes.insuranceType = this.insuranceType
    this.financeAttributes.transactionType = this.transactionType
    this.financeAttributes.companyId = this.companyId
    this.financeAttributes.requote = this.requote
    this.financeAttributes.policyMinDate = this.policyMinDate
    this.financeAttributes.amountsIfAddOn = this.amountsIfAddOn
    this.financeAttributes.recordName = this.recordName
    this.updateQuoteButton()
  },

  methods: {
    closeModal () {
      this.$store.dispatch('events/fireEvent', { name: 'finance-contract-close', data: null })
    },

    submit () {
      if(this.isEnteredManualActive === 0) {
        let insuranceType = this.financeAttributes.insuranceType;
        let isCommercialSwitchesSet = Object.values(this.financeAttributes.attributes).every(attribute => attribute !== null);
        let isPersonalSwitchesSet = (this.financeAttributes.attributes.assignedRisk !== null && this.financeAttributes.attributes.other !== null);
        if((insuranceType === 'Commercial' && !isCommercialSwitchesSet) || (insuranceType === 'Personal Lines' && !isPersonalSwitchesSet)) {
          this.messageString = "Parameters must be set to either Yes or No";
          this.$modal.show("MessagePopup");
        }
        else {
          let self = this;
          api.postRequest('customer/finance/integrated/request-quote', this.financeAttributes).then(
            (data) => {
              self.closeModal()
              data.data.results.requote = self.financeAttributes.requote
              data.data.results.companyId = self.financeAttributes.companyId
              data.data.results.policyIds = (self.financeAttributes.transactionType === 'convertQuote') ? [data.data.results.convertedPolicyId] : self.financeAttributes.policyIds
              data.data.results.policyMinDate = self.financeAttributes.policyMinDate
              data.data.results.amountsIfAddOn = self.financeAttributes.amountsIfAddOn
              self.$store.dispatch('events/fireEvent', { name: 'open-payment-selection', data: data.data.results })
            }
          ).catch(
            () => {
              self.messageString = "An error occurred while requesting a Quote.\n" +
                "Please re-check the configurations"
              self.$modal.show('MessagePopup')
            }
          )
        }
      } else {
        var self = this
        self.financeAttributes.attributes.assignedRisk = 0
        self.financeAttributes.attributes.auditable = 0
        self.financeAttributes.attributes.other = 0
        self.financeAttributes.attributes.parameterCode = 0
          if(self.policyIds !== "" && self.policyIds.split(',').length === 1){
          var policy = parseInt(self.policyIds)
          api.makeRequest('customer/' + self.customerId + '/policy/' + policy).then(
            (data) => {
              self.closeModal()
              var policy = data.data.results
              var url = "/ajax_customersDisplay.php?id=" + policy.custid + "&policyIds=" + policy.id + "&premiumFinanceForm=add&type=finance&financeCompanyId=" + policy.financeCompanyId + "&premiumAmount=" + policy.premium + "&policyFee=" + policy.policyfee + "&mgaFee=" + policy.mgaFee + "&tax=" + policy.tax
              this.$store.dispatch('events/fireEvent', { name: 'open-finance-tab', data: url })
            }
          )
        } else {
            self.closeModal()
        }
      }


    },

    isEnteredManual(){
      return (this.policyIds !== "" && this.policyIds.split(',').length === 1 && this.isManualContract == 1)
    },

    updateQuoteButton(){
      if(this.financeAttributes.attributes.isManualContract === 1 && this.policyIds !== "" && this.policyIds.split(',').length === 1){
          this.quoteButtonLabel = "Add Premium Finance"
          this.isEnteredManualActive = 1
          this.financeAttributes.attributes.assignedRisk = null
          this.financeAttributes.attributes.auditable = null
          this.financeAttributes.attributes.other = null
          this.financeAttributes.attributes.parameterCode = null
      } else {
          this.quoteButtonLabel = "Request a Quote"
          this.isEnteredManualActive = 0
      }
    }
  },

  components: {
      PaymentSelection,
      MessagePopup
  },

  watch: {
    'financeAttributes.attributes.isManualContract': {
      handler: function(){
        this.updateQuoteButton()
      }
    }
  }
}
</script>

<style scoped>
  .am-finance-contract-modal {
    background-color: whitesmoke;
  }
  .am-finance-contract-header {
    height: 35px;
    background-color: #428bca;
    padding: 10px;
    top: 0;
    color: white;
    font-weight: 700;
  }
.am-finance-contract-main-table{
  padding: 10px;
}

  .am-finance-contract-table {
    width: 100%;
    margin-bottom: 15px;
    font-weight: bold;
  }

  .am-finance-contract-toggle {
    margin: 0 0 0 0;
    float:left
  }

  .finance-contract-footer {
    height: 50px;
    width:100%;
    position:relative;
    bottom: 0;
    padding: 15px;
    border-top: 1px solid #428bca;
  }

  .finance-contract-footer button {
    margin-left: 5px;
    float: right;
  }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
